import { Button, CloseButton, Dialog } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

type DeleteClusterModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirmDiscard: () => void
}

export function DiscardModal({
  isOpen,
  onClose,
  onConfirmDiscard,
}: DeleteClusterModalProps) {
  const { t } = useTranslation('features')

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(details) => !details.open && onClose()}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header>
            <Dialog.Title>
              {t('organization.features.discardModal.title')}
            </Dialog.Title>
            <Dialog.CloseTrigger asChild>
              <CloseButton />
            </Dialog.CloseTrigger>
          </Dialog.Header>
          <Dialog.Body>
            {t('organization.features.discardModal.body')}
          </Dialog.Body>
          <Dialog.Footer>
            <Button variant="ghost" onClick={onClose}>
              {t('organization.features.actions.cancel')}
            </Button>
            <Button colorPalette="red" mr={3} onClick={onConfirmDiscard}>
              {t('organization.features.actions.discard')}
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  )
}
